import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {FormDefinitionFormDataService} from './impl/service/ngrx/formDefinitionFormData.service';
import {FormDefinitionFormConverter} from './api/entity/converter/formDefinitionForm.converter';
import {FormDefinitionFormSummaryDataServiceAdapter} from './impl/service/ngrx/formDefinitionFormSummaryDataService.adapter';
import {FormDefinitionFormRepository} from './impl/service/ngrx/formDefinitionForm.repository';
import {FormDefinitionFormSummaryConverter} from './api/entity/converter/formDefinitionFormSummary.converter';
import {FormDefinitionFormDataServiceAdapter} from './impl/service/ngrx/formDefinitionFormDataService.adapter';
import {FormDefinitionFormFieldConverter} from './api/entity/converter/formDefinitionFormField.converter';
import {errorMessages} from "../../../core/error/errorMessages";

@NgModule({
    providers: [
        FormDefinitionFormDataService,
        FormDefinitionFormSummaryDataServiceAdapter,
        FormDefinitionFormDataServiceAdapter,
        FormDefinitionFormRepository,
        FormDefinitionFormConverter,
        FormDefinitionFormSummaryConverter,
        FormDefinitionFormFieldConverter,
    ]
})
export class FormDefinitionFormModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                dataService: FormDefinitionFormDataService,
                service: FormDefinitionFormRepository,
    ) {

        entityDataService.registerServices({
            FormDefinitionForm: dataService,
        });

        entityServices.registerEntityCollectionServices({
            FormDefinitionForm: service,
        });

        errorMessages.set('FORM_DEFINITION_SAVE_NAME_ALREADY_EXISTS', 'Ce nom est déjà utilisé');
    }
}
